import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  allMonth,
  formLabelsTheme,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useStyles,
  useStylesReddit,
  validatePost,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

import { FormHelperText, TextField, ThemeProvider } from "@material-ui/core";
import {
  editOutboundCancel,
  editOutboundVehicle,
  fetchBookingPartyAll,
  selectOutboundPartyAll,
  selectLoading,
  fetchOutboundPartyAll,
  selectIdOutbound,
  fetchOutboundVehicle,
  fetchIdOutbound,
} from "./outboundSlice";
import { Autocomplete } from "@material-ui/lab";
import { selectPagination } from "../../modules/Auth";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const ModalEditVehicle = ({
  isOpen,
  setShow,
  row,
  setRow,
  formValues,
  setFormValues,
  id,
  getData,
  setGetData,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const classes = useStyles();
  const dataPartyAll = useSelector(selectOutboundPartyAll);
  const dataId = useSelector(selectIdOutbound);
  const paginationSet = useSelector(selectPagination);

  console.log(formValues, "formValues");

  useEffect(() => {
    if (getData === true) {
      dispatch(
        fetchOutboundPartyAll({
          outbound_id: id,
          party_carrier: "CARRIER",
          pageNo: 1,
          pageSize: -1,
        })
      );
      setGetData(false);
    }
  }, [getData]);

  useEffect(() => {
    if (row !== null) {
      setFormValues({
        ...formValues,
        party_id: {
          value:
            row.party_id === "00000000-0000-0000-0000-000000000000"
              ? ""
              : row.party_id,
          error: false,
          required: "Y",
        },
        timezone: {
          value: row.picking_timezone === null ? "" : row.picking_timezone,
          error: false,
          required: "Y",
        },
      });
    }
  }, [row]);

  const handleClose = () => {
    setRow(null);
    setShow(false);

    setFormValues({
      ...formValues,
      party_id: {
        value: "",
        error: false,
        required: "N",
      },
      party_name: {
        value: "",
        error: false,
        required: "N",
      },
      party_code: {
        value: "",
        error: false,
        required: "N",
      },
      timezone: {
        value: "",
        error: false,
        required: "N",
      },
    });
  };

  const handleSave = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }
    const params = [
      {
        outboundvehicle_id: row.outboundvehicle_id,
        vehicle_id: row.vehicle_id,
        party_id: formValues.party_id.value,
        picking_timezone: formValues.timezone.value,
      },
    ];
    try {
      const response = await dispatch(editOutboundVehicle(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        await dispatch(
          fetchOutboundVehicle({
            outbound_id: id,
            pageNo: 1,
            pageSize: paginationSet,
          })
        );
        await dispatch(fetchIdOutbound(id));
        await handleClose();
        await window.scrollTo(0, 1500);
        const action = await showSuccessDialog(response.payload.data.message);
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleChangeParty = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["party_id"]: {
        ...formValues["party_id"],
        value,
      },
    });
  };

  const partyOptions = dataPartyAll.map((e) => {
    return {
      value: e.party_id,
      label: e.party + "-" + e.party_name,
    };
  });

  const indexParty = partyOptions.findIndex(
    (obj) => obj.value === formValues.party_id.value
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {row && (
        <>
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={isOpen}
            onHide={handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter text-white">
                Add Carrier Information & Picking Time
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ThemeProvider theme={formLabelsTheme}>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      label="VIN"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={row.vin}
                      disabled
                    />
                    <RedditTextField
                      label="VON"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={row.von}
                      disabled
                    />
                    {/* <RedditTextField
                      label="Order No"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={row.order_no}
                      disabled
                    /> */}
                    <RedditTextField
                      required
                      label="Picking Timezone"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      fullWidth
                      size="small"
                      type="text"
                      name="timezone"
                      value={formValues.timezone.value}
                      onChange={handleChange}
                      error={formValues.timezone.error}
                      helperText={
                        formValues.timezone.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      label="Vehicle Name"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={row.product_description}
                      disabled
                    />
                    <RedditTextField
                      label="Accessories Installed"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={row.inbound_rule === "Y" ? "Yes" : "No"}
                      disabled
                    />
                    <Autocomplete
                      disablePortal
                      name="Carrier"
                      options={partyOptions}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      value={
                        partyOptions.find(
                          (option) => option.value === formValues.party_id.value
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        if (newValue === null) {
                          setFormValues({
                            ...formValues,
                            ["party_id"]: {
                              ...formValues["party_id"],
                              value: "",
                            },
                          });
                        } else {
                          setFormValues({
                            ...formValues,
                            ["party_id"]: {
                              ...formValues["party_id"],
                              value: newValue.value,
                            },
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <RedditTextField
                          required
                          className={classes.margin}
                          {...params}
                          label="Carrier"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          placeholder="Select"
                          name="party_id"
                          error={formValues.party_id.error}
                          helperText={
                            formValues.party_id.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      )}
                    />
                  </Col>
                </Row>
              </ThemeProvider>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              {dataId.outbound_status === "6110" && (
                <Button variant="primary" onClick={handleSave}>
                  Save
                </Button>
              )}
            </Modal.Footer>
          </Modal>
        </>
      )}
    </>
  );
};
